import formurlencoded from "form-urlencoded";
import { BASE_URL_LEGACY } from "./";

export const popupService = {
  getDetail,
  saveClose,
};

function getDetail() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  return (
    // fetch(`${BASE_URL}/common/popup/`, requestOptions)
    fetch(`${BASE_URL_LEGACY}/common/popup/`, requestOptions)
      .then((response) => {
        return handleResponse(response);
      })
      .then((detail) => {
        return detail;
      })
  );
}

function saveClose(id) {
  let response = `{"popups_read": [{"popup_id": ${id}, "show_again": false}]}`;
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    credentials: "include",
    body: response,
  };
  return fetch(`${BASE_URL_LEGACY}/common/popup/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
